import { markdownToHtml } from './prosemirrorMarkdown'

export function MarkdownContent({ text, className = '' }: { text: string; className?: string }) {
  return <div className={`ai-markdown ${className}`.trim()} dangerouslySetInnerHTML={{ __html: markdownToHtml(text) }} />
}
